import { FC } from "react";

import __ from "web/Layout/Translations";

import { Button, SxProps, Theme } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

interface IButtonBackProps {
  onClick: () => void;
  to?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  hasFullWidth?: boolean;
}

const CheckoutSubscriptionTemplateButtonBack: FC<IButtonBackProps> = ({
  to,
  sx,
  onClick,
  disabled,
  hasFullWidth = false,
}) => {
  return (
    <Button
      variant="outlined"
      size="large"
      color="inherit"
      sx={{
        borderColor: "grey.400",
        ...sx,
      }}
      href={to}
      onClick={onClick}
      disabled={disabled}
      data-t1="button_back"
      fullWidth={hasFullWidth}
    >
      <ChevronLeftIcon sx={{ mr: "8px" }} />
      {__("Wróć")}
    </Button>
  );
};

export default CheckoutSubscriptionTemplateButtonBack;
